import { RouteObject } from "react-router-dom";

// Customer-portal HSA questionnaire routes. Mounted at /hsa, scoped by
// the bearer-token-in-URL auth pattern: /hsa/<sessionToken>. No
// AuthGuard — the public token in the path IS the capability.
export const hsaRoutes: RouteObject[] = [
  {
    path: ":sessionToken",
    lazy: async () => {
      const { HsaPortalPage } =
        await import("@redotech/redo-customer-portal-app/portal-four/hsa/page");
      return { Component: HsaPortalPage };
    },
  },
];

// Partner LMN handoff survey, mounted at /hsa-survey/<sessionToken>. Distinct
// from /hsa: the handoff walk never persists answers (see HsaHandoffPage).
export const hsaHandoffRoutes: RouteObject[] = [
  {
    path: ":sessionToken",
    lazy: async () => {
      const { HsaHandoffPage } =
        await import("@redotech/redo-customer-portal-app/portal-four/hsa-survey/page");
      return { Component: HsaHandoffPage };
    },
  },
];
